var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentWarn = function SvgDocumentWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__a)",
    d: "M73.032 36.225V23.39c0-.336-.133-.66-.373-.898L57.912 7.762a1.27 1.27 0 0 0-.896-.371h-40.65c-.702 0-1.27.568-1.27 1.269v6.905H9.77c-.702 0-1.27.568-1.27 1.269v70.505c0 .702.568 1.27 1.27 1.27h54.292c.7 0 1.269-.568 1.269-1.27v-5.318h6.434c.7 0 1.269-.568 1.269-1.27v-12.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.887 15.957h-20.26c-.702 0-1.27.568-1.27 1.27V37.46c0 .7.568 1.269 1.27 1.269h20.26c.7 0 1.269-.568 1.269-1.27V17.227c0-.701-.57-1.269-1.27-1.269"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__b)",
    d: "M37.268 30.22h-.992a3.73 3.73 0 0 0 2.211-3.403 3.73 3.73 0 0 0-3.732-3.728 3.726 3.726 0 0 0-1.521 7.132h-.992c-2.584.022-4.69 2.14-4.69 4.725v3.784h14.406v-3.784c.002-2.585-2.106-4.703-4.69-4.725"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__c)",
    d: "M63.503 31.786H50.758a1.269 1.269 0 1 1 0-2.538h12.745a1.269 1.269 0 1 1 0 2.538"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__d)",
    d: "M63.503 38.73H50.758a1.269 1.269 0 1 1 0-2.539h12.745a1.269 1.269 0 1 1 0 2.538"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__e)",
    d: "M49.244 73.455H24.627a1.269 1.269 0 1 1 0-2.538h24.617a1.269 1.269 0 1 1 0 2.538"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__f)",
    d: "M16.365 82.021a1.27 1.27 0 0 1-1.269-1.269V15.565H9.77c-.702 0-1.27.568-1.27 1.27V87.34c0 .701.568 1.27 1.27 1.27h54.292c.7 0 1.269-.569 1.269-1.27v-5.319z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__g)",
    d: "M57.912 7.763a1.26 1.26 0 0 0-.896-.368V22.28c0 .614.498 1.112 1.112 1.112H73.03c0-.33-.127-.655-.37-.898z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__h)",
    d: "M37.268 30.22h-.992a3.7 3.7 0 0 1-1.521.324 3.7 3.7 0 0 1-1.521-.323h-.992c-2.584.022-4.69 2.14-4.69 4.725v3.784h14.406v-3.784c.002-2.585-2.106-4.703-4.69-4.725"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__i)",
    d: "M24.5 52.62h40.864c2.005-.12 1.505-2.62.136-2.539h-41a1.269 1.269 0 1 0 0 2.538"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__j)",
    d: "M24.626 45.676H69c1.677-.176 1.677-2.176 0-2.538H24.626a1.269 1.269 0 1 0 0 2.538"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__k)",
    d: "M61.68 63.97H24.626a1.269 1.269 0 1 0 0 2.539h38.162c.53 0 .986-.327 1.175-.792a16 16 0 0 1-2.283-1.746"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__l)",
    d: "M24.769 59.62h36.595c2.005-.12 1.505-2.62.136-2.539H24.769a1.269 1.269 0 1 0 0 2.538"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__m)",
    d: "M90.769 61.051 78.176 39.65C77.138 37.883 75.32 37 73.5 37l-6.772 16L73.5 69h12.592c4.157 0 6.755-4.416 4.677-7.949"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentWarn_svg__n)",
    d: "M68.824 39.65 56.23 61.05c-2.078 3.533.52 7.949 4.677 7.949H73.5V37c-1.819 0-3.637.883-4.676 2.65"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M73.5 45v11M73.5 62v2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.563 38.422 24.443)scale(99.8673 92.5335)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFCBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EDF8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.16473 14.1653 -13.02148 -11.18246 40.862 24.107)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.9054 2.29857 -.73802 -4.14364 63.61 29.413)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-12.9054 2.29857 -.73802 -4.14364 63.61 36.357)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(174.275 22.446 36.752)scale(23.0447 4.25377)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-47.98682 66.15254 -58.47742 -42.41932 61.007 20.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(133.026 34.073 19.82)scale(19.8188 18.3863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.647 15.967 21.314)scale(14.4002 12.1074)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.09593 2.29855 -.34742 -4.24667 54.1 50.246)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(175.672 27.475 22.72)scale(30.4558 4.2629)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(176.165 29.363 33.087)scale(34.3638 4.26552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "documentWarn_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.09593 2.29855 -.34742 -4.24667 54.369 57.246)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E8EAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B3CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "documentWarn_svg__m",
    x1: 79.114,
    x2: 79.114,
    y1: 34.529,
    y2: 80.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "documentWarn_svg__n",
    x1: 64.5,
    x2: 64.5,
    y1: 34.529,
    y2: 80.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgDocumentWarn;